import React from "react";
import { useSWRConfig } from "swr";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { InputField } from "./fields/InputField";
import { CheckboxField } from "./fields/CheckboxField";
import useGameStore from "../../lib/store/GameStore";
import usePersistentStore from "../../lib/store/PersistentStore";

export function LoginForm() {
  const { mutate } = useSWRConfig();

  const [setIsOpen, levelNumber] = useGameStore((state) => [
    state.setIsRegisterOpen,
    state.levelNumber,
  ]);
  const [browserId, loadSubmission] = usePersistentStore((state) => [
    state.browserId,
    state.loadSubmission,
  ]);

  return (
    <Formik
      //validateOnMount={true}
      initialValues={{
        email: "ryan5@test.com",
        password: "Rpower32!",
        _remember_me: true,
        browserId: browserId,
        level: levelNumber,
      }}
      validationSchema={Yup.object({
        email: Yup.string().required("Please enter your email address"),
        password: Yup.string().required("Please enter your password"),
      })}
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true);
        console.log("payload", values);
        const url = `${process.env.NEXT_PUBLIC_API_BASE_URL}/api/login`;

        fetch(url, {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(values),
        })
          .then((res) => {
            return res.json();
          })
          .then((data) => {
            loadSubmission(data.submission);

            mutate("/api/whoami", data, { revalidate: false });

            setIsOpen(false);
          });
      }}
    >
      {(formik) => (
        <Form className="space-y-6" action="#" method="POST">
          <div className="space-y-4">
            <InputField
              label="Email Address"
              id="email"
              name="email"
              type="email"
              autoComplete="email"
              placeholder="name@email.com"
            />
            <InputField
              label="Password"
              id="current-password"
              name="password"
              type="password"
              autoComplete="new-password"
              placeholder="••••••••"
            />
          </div>
          <div className="flex items-center justify-between">
            <CheckboxField
              label="Remember me"
              id="_remember_me"
              name="_remember_me"
            />
            {/*
            <a
              href="#"
              className="text-sm font-medium text-red-600 hover:underline dark:text-red-500"
            >
              Forgot password?
            </a> */}
          </div>

          <button
            type="submit"
            className={`w-full rounded-lg bg-red-600 px-5 py-2.5 text-center text-sm font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-4 focus:ring-red-300 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800 ${
              formik.isSubmitting && "loading"
            }`}
            disabled={formik.isSubmitting}
          >
            {formik.isSubmitting ? "Signing in..." : "Sign in"}
          </button>
        </Form>
      )}
    </Formik>
  );
}
